// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-66448cc2]{height:100%;width:100%;position:relative}.home header[data-v-66448cc2]{width:100%;height:70px}.home section[data-v-66448cc2]{position:absolute;top:5em;bottom:0;left:0;right:0;padding:20px 25px}.home .downloader[data-v-66448cc2]{height:0;width:0;visibility:hidden}\n", ""]);
// Exports
module.exports = exports;
